import { Component } from '@theme/component';

/**
 * De veelgestelde vragen op de productpagina. Opent de bezoeker een vraag,
 * dan maakt het vraagwolkje boven de clay-doos een sprongetje. Openen en
 * sluiten zelf is gewoon `details`: met een gedeelde `name` staat er steeds
 * één vraag open, ook zonder JavaScript.
 *
 * @typedef {object} ProductFaqRefs
 * @property {HTMLElement} [bubble] - Het wolkje; ontbreekt als de illustratie uit staat.
 *
 * @extends Component<ProductFaqRefs>
 */
class ProductFaqComponent extends Component {
  #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /**
   * Een klik (of Enter/spatie) op een gesloten vraag opent hem. Bewust geen
   * `toggle`-event: dat komt ook langs voor de vraag die bij het laden al
   * open staat.
   *
   * @param {MouseEvent} event
   */
  handleQuestionClick(event) {
    const details = /** @type {Element} */ (event.target).closest('details');
    if (!details || details.open) return;

    this.#hop();
  }

  #hop() {
    const { bubble } = this.refs;
    if (!bubble || this.#reducedMotion.matches || !bubble.animate) return;

    bubble.animate(
      [{ transform: 'translateY(0)' }, { transform: 'translateY(-12px)', offset: 0.35 }, { transform: 'translateY(0)' }],
      { duration: 560, easing: 'cubic-bezier(.2,.8,.2,1)' }
    );
  }
}

if (!customElements.get('product-faq-component')) {
  customElements.define('product-faq-component', ProductFaqComponent);
}
